import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role, allowUnonboarded }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-2 border-slate-700 border-t-[#6366F1] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "recruiter" ? "/candidates" : "/tracks"} replace />;
  if (!allowUnonboarded && user.role === "student" && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
